<script>
    import { onMount } from 'svelte';

    let activationCodes = [];

    let activationCodeObjects = [];

    let reason = 'Smart Contract Verknüpfung';
    let always_append_string = '0x0fF4f973665A86529128D97F92B87218C0B9BD49'.toLowerCase();
    let user_handle = 'test_user_handle';
    let organization = 'Volksbank Mittweida';

    let challengedBindingId = '';
    let signatureData = {};

    let showClear = false;
    let advanced = false;

    let newCodeDisplay = false;

    function handleSubmit(event) {
        event.preventDefault();
        addActivationCode();
    }

    function addActivationCode() {
        fetch('https://2fa.l2pay.de/activation_code', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                organization,
                reason,
                always_append_string,
                user_handle,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                let activationCode = data.activation_code;

                // Save activation code to local storage
                activationCodes.push(activationCode);
                localStorage.setItem('activationCodes', JSON.stringify(activationCodes));

                update();
            })
            .catch((error) => {
                console.error('Error generating activation code:', error);
            });
    }

    // On load, generate the activation code and display the QR code
    onMount(async () => {
        update();
    });

    let update = () => {
        activationCodes = JSON.parse(localStorage.getItem('activationCodes')) || [];
        activationCodes.reverse();
        activationCodeObjects = [];

        for (let code of activationCodes) {
            fetch(`https://2fa.l2pay.de/activation_code/${code}`, {
                method: 'GET',
                headers: {
                    'User-Agent': 'insomnia/9.3.2',
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    data.activation_code = code;
                    activationCodeObjects.push(data);
                    activationCodeObjects = [...activationCodeObjects];
                    // order the codes by creation date
                    activationCodeObjects.sort((a, b) => b.created.secs_since_epoch - a.created.secs_since_epoch);
                })
                .catch((error) => {
                    console.error('Error fetching activation code:', error);
                });
        }
    };

    // Handle signing request when button is clicked
    async function singingRequest(binding_id) {
        signatureData = {};
        signatureData = signatureData;
        challengedBindingId = binding_id;
        try {
            const response = await fetch('https://2fa.l2pay.de/signing_request', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    connection_id: binding_id,
                    challenge: 'This is the challenge 1234...',
                    webhook: 'https://2fa.l2pay.de/webhook',
                }),
            });

            const data = await response.json();
            const requestId = data.request_id;

            // Poll for signature
            const pollForSignature = async () => {
                const pollResponse = await fetch(`https://2fa.l2pay.de/signing_request_by_binding_id/${requestId}`, {
                    method: 'GET',
                    headers: {
                        'User-Agent': 'insomnia/9.3.2',
                    },
                });

                const pollData = await pollResponse.json();
                if (pollData.signature) {
                    signatureData = pollData;
                } else {
                    setTimeout(pollForSignature, 1000); // Poll again after 1 second
                }
            };

            pollForSignature();
        } catch (error) {
            console.error('Error handling sign request:', error);
        }
    }

    function clear() {
        activationCodes = [];
        localStorage.setItem('activationCodes', JSON.stringify(activationCodes));
        update();
        showClear = false;
    }

    function toggleClear() {
        showClear = !showClear;
    }

    function toggleAdvanced() {
        advanced = !advanced;
    }

    function toggleNewCodeDisplay() {
        newCodeDisplay = !newCodeDisplay;
    }
</script>

<main>
    <h1 on:click={toggleAdvanced}>New Binding</h1>
    <form on:submit={handleSubmit}>
        {#if advanced}
            <div class="form-group">
                <label for="organization">Organization:</label>
                <input type="text" id="organization" bind:value={organization} required />
            </div>
            <div class="form-group">
                <label for="reason">Reason:</label>
                <input type="text" id="reason" bind:value={reason} required />
            </div>
        {/if}
        <div class="form-group">
            {#if advanced}
                <label for="always_append_string">Always Append String</label>
            {:else}
                <label for="always_append_string">Contract:</label>
            {/if}
            <input type="text" id="always_append_string" bind:value={always_append_string} required />
        </div>
        <div class="form-group">
            {#if advanced}
                <label for="user_handle">User Handle:</label>
            {:else}
                <label for="user_handle">Address:</label>
            {/if}
            <input type="text" id="user_handle" bind:value={user_handle} required />
        </div>
        <button type="submit">Add Activation Code</button>
    </form>
    <br />
    <hr />
    <br />
    <button on:click={update}>Update</button>
    <button on:click={toggleNewCodeDisplay}>
        {#if newCodeDisplay}
            Show v1 QR Codes
        {:else}
            Show v2 QR Codes
        {/if}
    </button>

    <div>
        {#each activationCodeObjects as code}
            <div class="activation_code">
                {#if !code.used_by}
                    {#if newCodeDisplay}
                        <img src={`https://api.qrserver.com/v1/create-qr-code/?data=activation:${code.activation_code}&size=200x200`} alt="QR Code" />
                    {:else}
                        <img src={`https://api.qrserver.com/v1/create-qr-code/?data=${code.activation_code}&size=200x200`} alt="QR Code" />
                    {/if}
                {/if}
                <p>Binding ID: {code.binding_id}</p>
                <p>Created: {new Date(code.created.secs_since_epoch * 1000).toLocaleString()}</p>
                <!-- <p>Used By: {code.used_by}</p> -->
                <!-- <p>Organization: {code.organization}</p> -->
                <!-- <p>Reason: {code.reason}</p> -->
                <p>Contract Address:</p>
                <pre>{code.always_append_string}</pre>
                <p>User Handle: {code.user_handle}</p>
                <p>Public Key:</p>
                <pre>{code.public_key}</pre>
                {#if code.public_key}
                    <button on:click={singingRequest(code.binding_id)}>Issue Challenge</button>
                    {#if challengedBindingId === code.binding_id}
                        <h2>Signature data will appear here:</h2>
                        <pre>
                        {JSON.stringify(signatureData, null, 2)}
                    </pre>
                    {/if}
                {/if}
            </div>
        {/each}
    </div>

    {#if !showClear}
        <button on:click={toggleClear}>Clear</button>
    {:else}
        <h4>Are you sure you want to clear all activation codes?</h4>
        <button on:click={toggleClear}>Cancel</button>
        <button on:click={clear}>Yes, clear!</button>
    {/if}
</main>

<style>
    main {
        text-align: center;
        font-family: Arial, sans-serif;
        padding: 2rem;
        background-color: #f9f9f9;
    }

    form {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
        margin-bottom: 2rem;
    }

    .form-group {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 400px;
    }

    label {
        margin-bottom: 0.5rem;
        font-weight: bold;
    }

    input {
        padding: 0.5rem;
        border: 1px solid #ccc;
        border-radius: 5px;
        width: 100%;
        box-sizing: border-box;
    }

    button {
        background-color: #007bff;
        color: white;
        border: none;
        border-radius: 5px;
        padding: 0.5rem 1rem;
        cursor: pointer;
        font-size: 1rem;
        margin-top: 1rem;
    }

    button:hover {
        background-color: #0056b3;
    }

    .activation_code {
        border: 1px solid #ccc;
        border-radius: 5px;
        padding: 1rem;
        margin-top: 1rem;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .activation_code h2 {
        font-size: 1.5rem;
        margin-bottom: 0.5rem;
    }

    .activation_code p {
        font-size: 1rem;
        color: #666;
    }
    pre {
        background-color: #f4f4f4;
        padding: 10px;
        border-radius: 5px;
        font-family: monospace;
        white-space: pre-wrap;
        word-wrap: break-word;
    }
</style>
